// 文章弹窗

import styles from './index.less';
import $ from 'jquery';
import Modal from '../modal';
import { wwwUrl } from '../../utils/config';
import { iconfont } from '../../utils/utils';

const defaultPrams = {
  src: '',
  article: {
    title: '全景介绍',
    content: '',
  },
  showFooter: true,
};
export default class PanoInfo extends Modal {
  constructor(props) {
    super(props);
    this.params = {
      ...defaultPrams,
      ...props,
    };
    this._initContent();
  }
  _initContent() {
    const { article, showFooter } = this.params;
    this.$article = $(
      `<div class="${styles['article-wrapper']}">
        <div class="${styles['article-title']}">
          <span class="${styles['article-title-span']}">${article.title}</span>
          <span class="${styles['close-btn']}">
            ${iconfont('iconUC-quxiao',styles.iconfont)}
          </span>
        </div>
        <article class="${styles['article-content']}">${article.content}</article>
        ${
          showFooter
            ? `<div class="${styles['article-footer']}">VR全景制作工具：<a target="_blank" href="${wwwUrl}">jsvry.com</a></div>`
            : ''
        }
      </div>`,
    );
    this.$dom.append(this.$article);
    $(`.${styles['article-wrapper']} .${styles['close-btn']}`).on('click', () => {
      this.hide();
    });
  }
}
